<form [formGroup]="Newcostumer" (ngSubmit)="onSubmit()">

  <div class="grid grid-cols-2 gap-4">
    <!-- Nombre -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}</mat-label>
      <input formControlName="nombre"
            type="text"
            matInput
            placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.NAME' | translate }}" />
    </mat-form-field>

    <!-- Apellidos -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}</mat-label>
      <input formControlName="apellidos"
            type="text"
            matInput
            placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.SURNAME' | translate }}" />
    </mat-form-field>

    <!-- Municipio -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.MUNICIPALITY' | translate }}</mat-label>
      <input formControlName="municipio"
            type="text"
            matInput
            placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.MUNICIPALITY' | translate }}" />
    </mat-form-field>

    <!-- Código Postal -->
    <mat-form-field class="w-full">
      <mat-label>{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}</mat-label>
      <input formControlName="postal"
            type="text"
            matInput
            placeholder="{{ 'COMPONENTS.PROFILE.MY_PROFILE.EDIT_PROFILE.ZIPCODE' | translate }}" />
    </mat-form-field>

    <!-- ID Fiscal -->
    <mat-form-field class="w-full">
      <mat-label>ID Fiscal</mat-label>
      <input formControlName="id_fiscal"
            type="text"
            matInput
            placeholder="ID Fiscal" />
    </mat-form-field>

    <!-- Persona Física -->
    <mat-form-field class="w-full" [hidden]="true">
      <mat-label>¿Persona física?</mat-label>
        <input formControlName="personafisica" 
            type="text"
            matInput
            placeholder="Tarifa / Precio"/>
    </mat-form-field>

    <!-- Efectos Forma de Pago -->
    <mat-form-field class="w-full" [hidden]="true">
      <mat-label>Forma de Pago</mat-label>
      <input formControlName="efectos_forma_pago"
            type="text"
            matInput
            placeholder="Forma de Pago" />
    </mat-form-field>

    <!-- Efectos Banco -->
    <mat-form-field class="w-full">
      <mat-label>Banco</mat-label>
      <input formControlName="efectos_banco"
            type="text"
            matInput
            placeholder="Banco" />
    </mat-form-field>

    <!-- Factura por Correo -->
    <mat-form-field class="w-full">
      <mat-label>Factura por Email</mat-label>
      <mat-select formControlName="factura_mail">
        <mat-option value="1">Sí</mat-option>
        <mat-option value="0">No</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Factura en Papel -->
    <mat-form-field class="w-full">
      <mat-label>¿Factura en papel?</mat-label>
      <mat-select formControlName="factura_papel">
        <mat-option value="1">Sí</mat-option>
        <mat-option value="0">No</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Tarifa Precio -->
    <mat-form-field class="w-full" [hidden]="true">
      <mat-label>Tarifa / Precio</mat-label>
      <input formControlName="tarifa_precio" 
            type="text"
            matInput
            placeholder="Tarifa / Precio"
            />
    </mat-form-field>

    <!-- Botón Enviar -->
    <div class="mt-4">
      <button mat-raised-button color="primary" type="submit">
        {{ 'COMMON.CONFIRM' | translate }}
      </button>
    </div>
  </div>
</form>
